<div class="item-container">
    <div class="item-header">
        <h5 class="text-center">Unavailability on {{date}}</h5>
        <div class="edit-icons" mat-dialog-close>
            <i class="material-icons">close</i>
        </div>
    </div>
    <div class="item-content shift-container mat-mdc-table">
        <div *ngFor="let element of employeeArr" class="list-box d-flex justify-content-between">
            <div class="d-flex">
                <div class="profile-img me-2" [appBackgroundImg]="element.profile_picture"></div>
                <div class="">
                    <div class="main-head">{{element.full_name}}</div>
                    <div class="sub-head">{{element.email}}</div>
                </div>
            </div>
            <div>
                <div *ngFor="let time of element.time" class="text-danger">{{time.st_ti}} {{time.ed_ti}}</div>
                <div *ngIf="element.all_day==1" class="text-semibold text-danger">All day</div>
            </div>
        </div>
    </div>
</div>